import { useSettings } from '../lib/settings';
import { useT } from '../i18n';

/** The iLi mark from brand/ (never redrawn or recolored). */
export function IliMark({ size = 20, variant = 'color' }: { size?: number; variant?: 'color' | 'white' | 'black' }) {
  const src = variant === 'white' ? '/brand/ili-logo-white.svg' : variant === 'black' ? '/brand/ili-logo-black.svg' : '/brand/ili-logo.svg';
  // viewBox is 210 × 222
  return <img src={src} alt="" width={Math.round((size * 210) / 222)} height={size} style={{ display: 'inline-block' }} />;
}

export function PoweredBy({ variant = 'color' }: { variant?: 'color' | 'white' }) {
  const { poweredBy } = useSettings();
  const t = useT();
  return (
    <span className="powered-by">
      <IliMark size={16} variant={variant} />
      <span>{t('common.appPoweredBy', { name: poweredBy })}</span>
    </span>
  );
}

/** LGU name lockup for the header: seal (if any) + display name. */
export function LguLockup({ compact = false }: { compact?: boolean }) {
  const s = useSettings();
  return (
    <span className="lockup">
      {s.sealUrl ? <img src={s.sealUrl} alt={`${s.lguName} seal`} width={32} height={32} className="lockup-seal" /> : <IliMark size={28} />}
      <span className="lockup-text">
        <strong>{s.displayName}</strong>
        {!compact && <small>{s.lguTagline}</small>}
      </span>
    </span>
  );
}
